<template>
 <div class="rightnews">
 <div class="title">
      <span class="box-name">{{myProp}}</span>
      <!-- <a href="" class="more">更多</a> -->
    </div>
    <ul class="news-list" v-if="myPropType ==1">
     <li v-for="item in newsList1" :key="item.id"><a href="javascript:;" @click="goArticle(item.id)">{{item.title}}</a><span class="time">{{item.fbsjShort}}</span></li>

    </ul>
    <ul class="news-list" v-if="myPropType ==3">
     <li v-for="item in newsList3" :key="item.id"><a href="javascript:;" @click="goArticle(item.id)">{{item.title}}</a><span class="time">{{item.fbsjShort}}</span></li>

    </ul>
    <ul class="news-list" v-if="myPropType ==4">
     <li v-for="item in newsList4" :key="item.id"><a href="javascript:;" @click="goArticle(item.id)">{{item.title}}</a><span class="time">{{item.fbsjShort}}</span></li>

    </ul>
  </div>
</template>

<script>
export default {
  name: 'newslist',
  components: {},
  data () {
     return {
      title:'',
      newsList1:[],
      newsList3:[],
      newsList4:[]
   }
  },
  props:{
    myProp: {
         type: String,
         default: ''// 子组件在props中创建一个属性，用以接收父组件传过来的值
    },
    myPropType:{
      type: String,
      default: ''// 子组件在props中创建一个属性，用以接收父组件传过来的值
    }
  },
  watch: {

  },
  mounted() {
    this.findPageList(this.myPropType)
  },
  methods: {
     updata(){
       console.log(this.moduleId)
     },
     goArticle(articleId){

         let {href}= this.$router.resolve({
            path: "/Article",   // 这里写的是要跳转的路由地址
            query: {articleId:articleId,menutext:this.myProp}  // 这里写的是页面参数
         });
         window.open(href, '_blank');
     },
     findPageList(type){

       var that = this;
               		that.$myHttp.post("findPageList?type="+type+"&pageSize=6")
               		  .then(function(data) {
                       console.log(data)
               		    if (data.status == "200") {
                           if (type == 1 ){
                             that.newsList1 = data.data.page.list;
                           }
                           if (type == 3 ){
                             that.newsList3 = data.data.page.list;
                           }
                           if (type == 4 ){
                             that.newsList4 = data.data.page.list;
                           }
               		    }  else {
               		      alert("数据请求错误")
               		    }

               		  }).catch(function(error) {
               		    alert(error)
               		  })


     }
  }
};
</script>

<style scoped>
  .rightnews{

  }
  .newslist{
    width: 100%;
  }
.title{
  height:36px;
  line-height:36px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #199352;
}
.title .box-name{
  font-size:14px;
  color:#fff;
  background: #199352;
  font-weight: bold;
  padding:0 10px;
}
.title .more{
  color:#515151;
  font-size:12px;
  padding-right:15px;
  background: url(../../../assets/img/1.png) no-repeat right center;
}
.news-list{
  padding-top:10px;
  padding-bottom: 20px;
}

.news-list li{
  display: flex;
  justify-content: space-between;
}
.news-list li{
  display: flex;
  justify-content: space-between;
}
.news-list li a{
  font-size:14px;
  line-height:31px;
  display: block;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
   color:#666;
   width:70%;
   padding-left: 10px;
  background: url(/static/img/dot.jpg) left center no-repeat;
}
.news-list li a:hover{
  color: #6EAA24;
}
.news-list li .time{
  width:80px;
  ont-size: 12px;
      width: 80px;
      line-height: 31px;
      color: #999;
      text-align: right;
      font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/front/components/rightnews.vue